import ApiService from '@/services/core/api.service'

const AgentGroupService = {
  async get (query) {
    return ApiService.get(`supervisor/agent-groups?${query}`)
  },

  async post (payload) {
    return ApiService.post('supervisor/agent-groups', payload)
  },

  async put (payload) {
    return ApiService.put(`supervisor/agent-groups/${payload.id}`, payload)
  }
}

export default AgentGroupService
